module.exports = __webpack_public_path__ + "img/warning-icon.9bce440b.svg";